import { text } from './Constants'
import './Payment.scss'
import 'react-calendar/dist/Calendar.css'
import { PaymentMethods } from './components/payment-methods/PaymentMethods'
import { PaymentInfo } from './components/payment-info/PaymentInfo'

export const Payment = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  card,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  creditAmount,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  viewCards,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  addPaymentClick,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  price,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setPrice,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  methodError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  priceError,
}) => (
  <div className='review-book-visit-payment-container'>
    <label htmlFor='null' className='review-book-visit-payment-title'>
      {text.PAYMENT}
    </label>

    <PaymentMethods card={card} viewCards={viewCards} addPaymentClick={addPaymentClick} methodError={methodError} />

    <PaymentInfo creditAmount={creditAmount} price={price} setPrice={setPrice} priceError={priceError} />
  </div>
)
